export interface SponsorshipTier {
  name: string;
  subtitle: string;
  description: string;
  price: string;
  period: string;
  seats: number;
  features: string[];
  cta: string;
  ctaUrl?: string;
}

export interface AddOn {
  name: string;
  description: string;
  price: string;
  details: string;
}

export interface ValueStory {
  title: string;
  description: string;
}

export const sponsorshipTiers: SponsorshipTier[] = [
  {
    name: "Solo",
    subtitle: "Advisor Platform License",
    description: "Up to 5 Households",
    price: "$2,000",
    period: "/ Year",
    seats: 5,
    features: [
      "5 ThriveMax household licenses",
      "Advisor dashboard access",
      "Client engagement tracking",
      "Quarterly impact summary",
      "Co-branded onboarding materials",
      "Priority advisor support"
    ],
    cta: "Start Partnership",
    ctaUrl: "https://app.seniorthrive.com/sponsor/signup?plan=solo"
  },
  {
    name: "Core", 
    subtitle: "Advisor Platform License",
    description: "Up to 10 Households",
    price: "$3,750",
    period: "/ Year",
    seats: 10,
    features: [
      "10 ThriveMax household licenses",
      "Everything in Strategic Entry",
      "Portfolio-level client view",
      "Client safety status summaries",
      "Advisor marketing toolkit"
    ],
    cta: "Start Partnership",
    ctaUrl: "https://app.seniorthrive.com/sponsor/signup?plan=core"
  },
  {
    name: "Growth",
    subtitle: "Advisor Platform License",
    description: "Up to 20 Households", 
    price: "$7,000",
    period: "/ Year",
    seats: 20,
    features: [
      "20 ThriveMax household licenses",
      "Everything in Core",
      "Advanced engagement analytics",
      "Annual strategy review"
    ],
    cta: "Start Partnership",
    ctaUrl: "https://app.seniorthrive.com/sponsor/signup?plan=growth"
  },
  {
    name: "Scale",
    subtitle: "Advisor Platform License",
    description: "Up to 50 Households",
    price: "$16,000",
    period: "/ Year",
    seats: 50,
    features: [
      "50 ThriveMax household licenses",
      "Everything in Growth",
      "Dedicated partner success lead",
      "Aggregated reporting exports",
      "Co-marketing collaboration"
    ],
    cta: "Contact Sales"
  }
];

export const addOns: AddOn[] = [
  {
    name: "ThriveFamily Upgrade",
    description: "Add $225 per seat per year",
    price: "+$225/seat/year",
    details: "Extend coverage to include family members in the ThriveCircle"
  },
  {
    name: "Concierge Onboarding",
    description: "$50 per client for one-on-one kick-off call",
    price: "$50/client",
    details: "Personalized onboarding experience for each household"
  }
];

export const valueStories: ValueStory[] = [
  {
    title: "Meaningful Differentiation",
    description: "Stand for more than transactions. Offer structured support that helps older adults live safely and independently at home."
  },
  {
    title: "Stronger Relationships",
    description: "Stay relevant during major life transitions. Be present when conversations shift from planning to real-world aging decisions."
  },
  {
    title: "Low Operational Lift",
    description: "Simple sponsorship model. No complex implementation. Households activate directly inside SeniorThrive."
  },
  {
    title: "Clear Value to the People You Serve",
    description: "Support safety, communication, and coordination in one place — something families will actually use."
  }
];
